<template>
  <div id="chart-line-item-item-box">
    <chart-title leftTitle="SCM采购价格波动数据（板材） right_2"></chart-title>
    <date-change-card
      height="calc(100% - 30px)"
      @leftClick="leftClick"
      @rightClick="rightClick"
    >
      <div id="right_2" slot="main" />
    </date-change-card>
  </div>
</template>

<script>
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
import DateChangeCard from "../../../components/dateChangeCard";
export default {
  mixins: [resize],
  name: "right_2",
  components: { ChartTitle, DateChangeCard },
  data() {
    return {
      chart: null,
    };
  },
  props: {},
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },

  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = this.$echarts.init(document.getElementById("right_2"));
      this.setOptions();
    },
    setOptions() {
      this.chart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          orient: "horizontal",
          left: "center",
          bottom: "2%",
          textStyle: {
            color: "#C0C4CC",
            fontSize: "10",
          },
        },
        grid: {
          right: "16%",
          left: "13%",
          top: "4%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
          axisLabel: {
            color: "#606266",
            fontSize: "10",
          },
          axisLine: {
            lineStyle: {
              color: "#606266",
            },
          },
          splitLine: {
            lineStyle: {
              color: "#606266",
              type: "dashed", //设置网格线类型 dotted：虚线 solid:实线
            },
          },
        },
        yAxis: {
          type: "category",
          axisLine: {
            lineStyle: {
              color: "#606266",
            },
          },
          axisLabel: {
            color: "#909399",
            fontSize: "10",
          },
          data: [
            "18-千年舟-铁灰",
            "18L-陨石无标",
            "18-鲁丽-胡桃木ENF",
            "18-亿维维-IE-1109",
            "25L-麦园黄",
            "18PET-柳絮白",
          ],
        },
        series: [
          {
            name: "采购价",
            type: "bar",
            barWidth: 5,
            data: [
              498, 428, 400, 322, 463, 321, 203, 489, 234, 170, 131, 230, 100,
              134, 230,
            ],
            color: new this.$echarts.graphic.LinearGradient(1, 0, 0, 0, [
              { offset: 0, color: "rgba(21,157,255,1)" },
              { offset: 1, color: "rgba(21,157,255,0.1)" },
            ]),
            itemStyle: {
              normal: {
                borderRadius: 5,
              },
            },
          },
          {
            name: "最高价",
            type: "bar",
            barWidth: 5,
            barGap: "100%",
            data: [
              498, 428, 400, 322, 463, 321, 203, 489, 234, 170, 131, 230, 100,
              134, 230,
            ],
            color: new this.$echarts.graphic.LinearGradient(1, 0, 0, 0, [
              { offset: 0, color: "rgba(34,228,255,1)" },
              { offset: 1, color: "rgba(34,228,255,0.1)" },
            ]),
            itemStyle: {
              normal: {
                borderRadius: 5,
              },
            },
          },
          {
            name: "最低价",
            type: "bar",
            barWidth: 5,
            data: [
              498, 428, 400, 322, 463, 321, 203, 489, 234, 170, 131, 230, 100,
              134, 230,
            ],
            color: new this.$echarts.graphic.LinearGradient(1, 0, 0, 0, [
              { offset: 0, color: "rgba(59,255,208,1)" },
              { offset: 1, color: "rgba(59,255,208,0.1)" },
            ]),
            itemStyle: {
              normal: {
                borderRadius: 5,
              },
            },
          },
        ],
      });
    },
    //前一月
    leftClick() {
      console.log("leftClick");
    },
    //后一月
    rightClick() {
      console.log("rightClick");
    },
  },
};
</script>

<style lang="scss" scoped>
#chart-line-item-item-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 50vh;
  #right_2 {
    height: 100%;
  }
}
</style>
